<div nz-row nzGutter="8" class="em-area">
  <div nz-col nzSpan="20">
    <em-element-history-log class="em-area"></em-element-history-log>
  </div>
  <div nz-col nzSpan="4">
    <em-element-history-document-link class="em-area"></em-element-history-document-link>
    <em-sirius-element-history-document-link
      class="em-area"
    ></em-sirius-element-history-document-link>
  </div>
</div>
